import PropTypes from "prop-types";
import ReportHeader from "./ReportHeader";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const LeadSourcesHeaders = ({ sortBy, sortKey, sortDesc, sourceTypeTitle, isOtherSources }) => (
  <>
    <TR>
      <TD className="tw-bg-white" colSpan="11">
        {sourceTypeTitle}
      </TD>
    </TR>
    <TR>
      <ReportHeader
        name={isOtherSources ? "other_source" : "source"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Source"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_new" : "new"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="New"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_unqualified" : "unqualified"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Unqualified"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_watch" : "watch"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Watch"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_nurture" : "nurture"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Nurture"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_hot" : "hot"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Hot"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_past" : "past"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Past"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_inactive" : "inactive"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Inactive"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_archived" : "archived"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Archived"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_trash" : "trash"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Trash"
        handleSort={sortBy}
      />
      <ReportHeader
        name={isOtherSources ? "other_total_leads" : "total_leads"}
        sortDesc={sortDesc}
        sortKey={sortKey}
        label="Total Leads"
        handleSort={sortBy}
      />
    </TR>
  </>
);

LeadSourcesHeaders.propTypes = {
  sortBy: PropTypes.func.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
  sourceTypeTitle: PropTypes.string.isRequired,
  isOtherSources: PropTypes.bool,
};

LeadSourcesHeaders.defaultProps = {
  isOtherSources: false,
};

export default LeadSourcesHeaders;
